<template>
  <div class="dashboard-container">
    <div class="user-num">
      <div class="user-box">
        <li
          v-if="rankingShow"
          style="cursor: pointer"
          @click="viewIncomeRanking"
        >
          <img src="../../assets/image/money.png" />
          <span class="key"
            >个人累计收益(￥)：<span class="value">{{
              selfAgent.selfIncome || 0
            }}</span></span
          >
        </li>
        <li
          v-if="rankingShow"
          style="cursor: pointer"
          @click="viewIncomeRanking"
        >
          <img src="../../assets/image/ranking.png" />
          <span class="key"
            >个人累计排名：<span class="value"
              >{{ selfAgent.rankingNum }}/{{ selfAgent.teamNum }}</span
            ></span
          >
        </li>
        <li>
          <img src="../../assets/image/icon-user.png" />
          <span class="key"
            >用户人数：<span class="value">{{ userCount }}</span></span
          >
        </li>
        <li>
          <img src="../../assets/image/icon-online.png" />
          <span class="key"
            >在线人数：<span class="value">{{ userOnline }}</span></span
          >
        </li>
        <el-button size="small" round @click="reload">刷新 </el-button>
        <el-button
          size="small"
          round
          @click="userOnlineVisible = true"
          v-if="userOnline > 0"
          >查看
        </el-button>
      </div>
    </div>
    <div class="dashboard-text">人才评价系统</div>
    <el-dialog
      title="在线用户详情"
      :visible.sync="userOnlineVisible"
      width="800px"
    >
      <el-row>
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline search-form"
          size="small"
        >
          <el-form-item>
            <el-input
              v-model="searchForm.realName"
              clearable
              placeholder="用户姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchOnlineUser"
              >查询
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-table :data="userList">
        <el-table-column
          label="姓名"
          prop="realName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="证件号码"
          prop="idNumber"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        class="footer"
        background
        :layout="tableLayout"
        :total="tableTotal"
        :current-page="currentPage"
        :page-size.sync="pageSize"
        @current-change="onCurrentPageChange"
        @size-change="handleSizeChange"
        :page-sizes="[20]"
        align="center"
      >
      </el-pagination>
    </el-dialog>
    <el-dialog title="收益排名" :visible.sync="showIncomeRanking" width="650px">
      <el-row>
        <div style="margin-bottom: 20px">
          <el-radio-group v-model="incomeDate">
            <el-radio-button label="today">日</el-radio-button>
            <el-radio-button label="week">周</el-radio-button>
            <el-radio-button label="month">月</el-radio-button>
            <el-radio-button label="all">累计</el-radio-button>
          </el-radio-group>
        </div>
      </el-row>
      <el-table :data="agentList">
        <el-table-column
          label="排名"
          type="index"
          :index="1"
          align="center"
        ></el-table-column>
        <el-table-column
          label="机构"
          prop="agentName"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="收益"
          prop="selfIncome"
          align="center"
          :formatter="incomeFormatter"
        ></el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        个人收益：<span style="color: red;">{{
          selfAgent.selfIncome || 0
        }}</span>
        ---- 个人排名：<span style="color: red;"
          >{{ selfAgent.rankingNum }}/{{ selfAgent.teamNum }}</span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getExamUrl, getOnlineUsers, getOnlineUsersList } from "@/api/auth";
import { getAgentRanking } from "@/api/agentInfo";
import "echarts/lib/chart/bar";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import { defaultPageConfig } from "@/config/pagination";
export default {
  name: "Dashboard",
  data: function() {
    return {
      userCount: 0,
      userOnline: 0,
      userOnlineVisible: false,
      userList: null,
      searchForm: {
        realName: ""
      },
      agentForm: {
        startTime: null,
        endTime: null
      },
      agentList: [],
      agentOptions: {},
      selfAgent: {},
      rankingShow: false,
      showIncomeRanking: false,
      incomeDate: "all",
      tableLayout: defaultPageConfig.layout,
      pageSize: 20,
      currentPage: 1,
      tableTotal: 0,
      tablePages: 0
    };
  },
  watch: {
    incomeDate() {
      this.searchAgentIncom();
    }
  },
  computed: {},
  created() {
    this.getExamUrl();
    this.getOnlineUsers();
    this.getOnlineUsersList();
    this.getAgentIncomTree();
  },
  mounted() {},
  methods: {
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.getOnlineUsersList();
    },
    handleSizeChange() {
      this.getOnlineUsersList();
    },
    getExamUrl() {
      getExamUrl().then(res => {
        if (res && res.code === 200) {
          if (res.data.pcUrl) {
            localStorage.setItem("pcUrl", res.data.pcUrl);
          }
          if (res.data.h5Url) {
            localStorage.setItem("h5Url", res.data.h5Url);
          }
          if (res.data.gUrl) {
            localStorage.setItem("gUrl", res.data.gUrl);
          }
        }
      });
    },
    getOnlineUsers() {
      getOnlineUsers().then(res => {
        if (res && res.code === 200) {
          if (res.data.userCount) {
            this.userCount = res.data.userCount;
          }
          if (res.data.userOnline) {
            this.userOnline = res.data.userOnline;
          } else {
            this.userOnline = 0;
          }
        }
      });
    },
    getOnlineUsersList() {
      this.searchForm.page = this.currentPage;
      this.searchForm.pageSize = this.pageSize;
      getOnlineUsersList(this.searchForm).then(res => {
        if (res.code === 200 && res.data) {
          this.userList = res.data.list;
          this.tableTotal = Number(res.data.total);
          this.tablePages = Number(res.data.pages);
        } else {
          this.userList = null;
          this.tableTotal = 0;
          this.tablePages = 0;
        }
      });
    },
    searchOnlineUser() {
      this.getOnlineUsersList();
    },
    reload() {
      this.getOnlineUsers();
      this.getOnlineUsersList();
    },
    searchAgentIncom() {
      this.incomeDateFormatter(this.incomeDate);
      this.getAgentIncomTree();
    },
    incomeDateFormatter(param) {
      if (param && param == "today") {
        let now = new Date();
        let year = now.getFullYear();
        let m = now.getMonth() + 1;
        let date = now.getDate();
        let t = year + "-" + m + "-" + date;
        this.agentForm.startTime = t;
        this.agentForm.endTime = t;
      } else if (param && param == "week") {
        let date = new Date();
        // 本周一的日期
        date.setDate(date.getDate() - date.getDay() + 1);
        let begin =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " 00:00:00";
        date.setDate(date.getDate() + 6);
        let end =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " 23:59:59";
        this.agentForm.startTime = begin;
        this.agentForm.endTime = end;
      } else if (param && param == "month") {
        let date = new Date();
        date.setDate(1);
        let year = date.getFullYear();
        let m = date.getMonth() + 1;
        let one = date.getDate();
        let first = year + "-" + m + "-" + one;
        let currentMonth = date.getMonth();
        let nextMonth = ++currentMonth;
        let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
        let oneDay = 1000 * 60 * 60 * 24;
        let lastDay = new Date(nextMonthFirstDay - oneDay).getDate();
        let last = year + "-" + m + "-" + lastDay;
        this.agentForm.startTime = first;
        this.agentForm.endTime = last;
      } else {
        this.agentForm.startTime = null;
        this.agentForm.endTime = null;
      }
    },
    getAgentIncomTree() {
      getAgentRanking(this.agentForm).then(res => {
        let that = this;
        if (res && res.code == 200) {
          that.agentList = [];
          if (res.data && res.data.self && res.data.self.metaName) {
            this.rankingShow = true;
            let sAgent = res.data.self;
            let i = 0;
            res.data.agentList.map(item => {
              i++;
              if (i <= 10) {
                that.agentList.push(item);
              }
              if (item.agentId.toString() == sAgent.agentId.toString()) {
                that.selfAgent = item;
                that.selfAgent.rankingNum = i;
              }
            });
            that.selfAgent.teamNum = res.data.agentList.length;
            this.initAgentOptions();
          }
        }
      });
    },
    initAgentOptions() {
      let labels = [];
      let incomes = [];
      this.agentList.map(item => {
        labels.push(item.agentName);
        incomes.push(item.selfIncome);
      });
      this.agentOptions = {
        grid: {
          left: "3%",
          right: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          type: "category",
          data: labels,
          axisLabel: {
            rotate: 30, // 旋转角度
            interval: 0
          }
        },
        yAxis: {
          type: "value",
          splitNumber: 10,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: "收益",
            symbolSize: 5,
            color: "#65B3A5",
            symbol: "circle",
            barWidth: 30,
            itemStyle: {
              color: function(params) {
                let colorList = [
                  "#9FC1D0",
                  "#72A9C2",
                  "#5397B7",
                  "#9FA8D0",
                  "#8E99C7",
                  "#6C7AB7",
                  "#BEDFD9",
                  "#9FD0AF",
                  "#65B3A5"
                ];
                return colorList[params.dataIndex];
              }
            },
            data: incomes,
            smooth: 0.6,
            type: "bar"
          }
        ]
      };
    },
    viewIncomeRanking() {
      this.showIncomeRanking = true;
    },
    incomeFormatter(row) {
      if (!row.selfIncome) {
        return 0;
      } else {
        return row.selfIncome;
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    justify-content: center;
    min-height: calc(100vh - 164px);
    text-align: center;
    background: url("../../assets/Group@2x.png") no-repeat;
    background-size: 100% 100%;
  }
  &-text {
    height: 40px;
    font-size: 2.5vh;
    font-family: AlibabaPuHuiTiR;
    color: rgba(17, 17, 17, 1);
    line-height: 40px;
    margin-top: 24vh;
  }
}
.user-num {
  width: 100%;
  height: 55px;
  background-color: #fff;
  box-shadow: 5px 0 5px rgba(0, 0, 0, 0.2);
}
.user-num .user-box {
  height: 55px;
  float: right;
  margin-right: 65px;
}
.user-num .user-box li {
  height: 55px;
  float: left;
  list-style: none;
  margin-left: 50px;
  line-height: 55px;
}
.user-num .user-box li img {
  vertical-align: middle;
  width: 31px;
  height: 31px;
}
.user-num .user-box li .key {
  margin-left: 5px;
}
.user-num .user-box button {
  margin-top: 12px;
  background-color: #b2c0d8;
  color: #fff;
  text-align: center;
  border: none;
  border-radius: 2px;
  margin-left: 20px;
}
.user-num .user-box button:hover {
  background-color: #7a8eb0;
  transition: 0.5s;
  cursor: pointer;
}
.el-form--inline .el-form-item {
  float: left;
}
.agentRanking {
  width: 50%;
  margin: 0 auto;
}
</style>
